import { toast } from "react-toastify"

const TOAST_ERROR_STYLE = {
    backgroundColor: "#f44336",
    color: "#fff",
    padding: "16px",
    borderRadius: "10px",
    border: "2px solid #D32F2F",
    fontSize: "16px"
}

const TOAST_SUCCESS_STYLE = {
    backgroundColor: "#4caf50",
    color: "#fff",
    padding: "16px",
    borderRadius: "10px",
    border: "2px solid #388e3c",
    fontSize: "16px"
}

export const useToast = () => {
    const showErrorToast = (message: string) => {
        toast.error(message, { style: TOAST_ERROR_STYLE })
    }

    const showSuccessToast = (message: string) => {
        toast.success(message, { style: TOAST_SUCCESS_STYLE })
    }

    return {
        showErrorToast,
        showSuccessToast
    }
}
